import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';

// The following "route matches" track relevant path parameters
// Intended for use outside of the react router context (where useParams does not work)
const useRouteParams = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const customerRoute = matchPath(
      { path: '/customers/:customerId', end: false },
      pathname,
    );
    const customerAccountRoute = matchPath(
      { path: '/customers/:customerId/accounts/credit/:accountId', end: false },
      pathname,
    );
    const applicationRoute = matchPath(
      { path: '/applications/:applicationId', end: false },
      pathname,
    );

    return {
      customerId: customerRoute?.params.customerId,
      accountId: customerAccountRoute?.params.accountId,
      applicationId: applicationRoute?.params.applicationId,
    };
  }, [pathname]);
};

export default useRouteParams;
